import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { FaChevronLeft, FaExclamationCircle } from 'react-icons/fa';
import * as Styled from './styled';
import type { NotFoundPageProps } from './types';

export * from './types';

export const NotFoundPage: FC<NotFoundPageProps> = (props) => {
  const { onBackClick } = props;
  const { translate } = useTranslation();

  return (
    <Styled.Wrapper>
      <Styled.IconWrapper>
        <FaExclamationCircle />
      </Styled.IconWrapper>
      <Styled.Title>{translate('notFound.title')}</Styled.Title>
      {!!onBackClick && (
        <Styled.BackWrapper onClick={onBackClick}>
          <FaChevronLeft />
          <div>{translate('common.buttons.backToHome')}</div>
        </Styled.BackWrapper>
      )}
    </Styled.Wrapper>
  );
};
